import { Component, Input, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigTituloPaginasService } from '@appNeo/core/services/config-titulo-paginas.service';
import { HelpersService } from '@appNeo/neoCore/services/helpers/helpers.service';
import { EdicionSeccionesService } from '@appNeo/neoShared/modules/edicion-secciones/edicion-secciones.service';
import { environment } from '@environments/environment';

import { PAGINAS_ROUTES } from '@appNeo/pages/pages-routes-data';
import { ProximamenteDlgComponent } from '@appNeo/pages/components/proximamente-dlg/proximamente-dlg.component';
import { PreferenciasService } from '@appNeo/neoCore/services/preferencias/preferencias.service';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { ConstantesConfiguracionCalendarioEnum } from '@appNeo/core/helpers/enums/constantesConfiguracionCalendarioEnum';
import { finalize } from 'rxjs';

@Component({
  selector: 'neo-otros-eventos',
  templateUrl: './otros-eventos.component.html',
  styleUrls: ['./otros-eventos.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OtrosEventosComponent implements OnInit {

  @Input() pathReservar: string = '/' + PAGINAS_ROUTES.PAGINA_RESERVAR;
  @Input() constanteComprobarAccion = ConstantesConfiguracionCalendarioEnum.AccesoAltaReservasPublico;
  @ViewChildren(ProximamenteDlgComponent) accionesDialogoProximamente: QueryList<ProximamenteDlgComponent>;
  precargarOeTop;
  precargarOeEventos;
  precargaMeta;
  top_titulo = '';
  top_texto = 'top-txt';
  eventos: any[] = [];  

  constructor(
    private helpersService: HelpersService,
    private edicionSeccionesService: EdicionSeccionesService,
    private route: ActivatedRoute,
    private confTitulo: ConfigTituloPaginasService,
    private router: Router,
    private preferenciasService: PreferenciasService,
    private auxiliarService: AuxiliarService
  ) {
    this.route.data.subscribe(
      response => {
        console.log('RESPONSE ZONA FAN', response);
        this.precargarOeTop = response.seccionesEditables.oe_top;
        this.precargarOeEventos = response.seccionesEditables.oe_eventos;
        this.precargaMeta = response.seccionesEditables.precargaMeta;
      }
    );
  }

  ngOnInit(): void {
    this.iniciarPagina();
  }

  iniciarPagina(){
    if (this.helpersService.hayModulo('edicion')) {
      // **********************************
      // Titulo y meta
      // **********************************
      this.confTitulo.establecerTitulo('Otros eventos', 'oe-meta', this.precargaMeta, 'meta-tit');
      this.confTitulo.establecerMeta(environment.descripcionMetaDefecto, 'oe-meta', this.precargaMeta, 'meta-des');
      // this.edicionSeccionesService.getContenidoBloquesSubseccion('oe-top').subscribe(data => {
      this.precargarOeTop.elementos.forEach((elemento, index) => {
        let indice = (this.precargarOeTop.multiple) ? index : -1;
        this.top_titulo = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'oe-top-tit', indice);
          this.top_texto = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'oe-top-txt', indice);
          return;
        });
      // });
      // this.edicionSeccionesService.getContenidoBloquesSubseccion('oe-eventos').subscribe(data => {
      this.precargarOeEventos.elementos.forEach((elemento, index) => {
        let indice = (this.precargarOeEventos.multiple) ? index : -1;
          let evento = {
            tit: this.edicionSeccionesService.getCamposEdicionItem(elemento, 'oe-eventos-tit', indice),
            txt: this.edicionSeccionesService.getCamposEdicionItem(elemento, 'oe-eventos-txt', indice),
            img1: this.edicionSeccionesService.getCamposEdicionItem(elemento, 'oe-eventos-img1', indice),
            img2: this.edicionSeccionesService.getCamposEdicionItem(elemento, 'oe-eventos-img2', indice),
          };
          this.eventos.push(evento);
        });
      // });
    }
  }

  reservar() {
    this.validarAccion();
  }

  desencadenarAccion: boolean = !environment.proximamente_reservas;
  accion(data?: any) {
    if (this.desencadenarAccion) {
      this.router.navigate([`/${this.pathReservar}`]);
    } else {
      this.mostrarProximamente();
    }
  }
  validarAccion(data?: any) {
    this.preferenciasService.getApi(this.constanteComprobarAccion, true)
      .pipe(
        finalize(() => {
          this.accion(data);
        })
      )
      .subscribe(
        x => this.desencadenarAccion = this.auxiliarService.getBoolean(x.valor),
        e => this.desencadenarAccion = this.auxiliarService.getBoolean(this.preferenciasService.get(this.constanteComprobarAccion))
      );
  }
  mostrarProximamente() {
    this.accionesDialogoProximamente.first.abrirDialogo();
  }
}
